<div class="status-cards-wrapper" [ngClass]="{'show': tooltipOpen}" appClickOutside (clickOutside)="hideCardTooltip()" (mouseenter)="handleCardClick()" (mouseleave)="handleCardClick()"
  [isActive]="tooltipOpen">
  <div class="stacked-cards">
    <ng-container *ngFor="let status of bookingStatus">
      <div [ngClass]="status.styleClass + ' ' + status.orderClass" class="status-card">
        <img src="{{status.denoter}}" alt="status card icon">
      </div>
    </ng-container>
  </div>
  <div class="status-tooltip" *ngIf="bookingStatus.length">
    <div class="status-row" *ngFor="let status of bookingStatus">
      <div [ngClass]="status.styleClass" class="status-icon">
        <img src="{{status.denoter}}" alt="status card icon ">
      </div>
      <div>{{status.descriptor}}</div>
    </div>
  </div>
</div>